export default __webpack_public_path__ + "static/media/emptyexperts.24f4885a.svg";